import { useEffect, useState } from "react";
import axios from "axios";
import { Cookie } from "lucide-react";

const KEY = "pgp_cookie_consent";

// Banner consenso cookie per gli utenti esterni (portale professionisti e area clienti).
export default function CookieBanner() {
  const [testo, setTesto] = useState("");
  const [show, setShow] = useState(() => !localStorage.getItem(KEY));
  useEffect(() => {
    if (!show) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/gdpr`).then(({ data }) => setTesto(data.cookie_testo || "")).catch(() => {});
  }, [show]);
  if (!show) return null;
  const scegli = (scelta) => { localStorage.setItem(KEY, JSON.stringify({ scelta, at: new Date().toISOString() })); setShow(false); };
  return (
    <div className="fixed bottom-0 inset-x-0 z-[150] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto rounded-xl border border-slate-200 bg-white text-slate-700 shadow-2xl p-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <Cookie className="h-6 w-6 text-amber-500 shrink-0 hidden sm:block" />
        <p className="text-sm flex-1" data-testid="cookie-banner-testo">{testo || "Questo sito utilizza solo cookie tecnici necessari al funzionamento."}</p>
        <div className="flex gap-2 shrink-0">
          <button type="button" onClick={() => scegli("necessari")} data-testid="cookie-banner-necessari"
            className="px-3 py-2 rounded-md text-sm border border-slate-300 hover:bg-slate-100 transition-colors">Solo necessari</button>
          <button type="button" onClick={() => scegli("tutti")} data-testid="cookie-banner-accetta"
            className="px-3 py-2 rounded-md text-sm font-semibold bg-amber-500 text-[#0a0d14] hover:bg-amber-400 transition-colors">Accetta</button>
        </div>
      </div>
    </div>
  );
}
